import React, { Component } from 'react';
import { Icon } from 'react-fa';
import Menu, { Item as MenuItem } from 'rc-menu';

const CheckboxEstado = () => {

    return (
        <span className="ChildCheckbox default-checkbox IconoVerificarVerde ">
            <input type="checkbox" id="checkbox-status" name="checkbox-status" value="off" />
            <label className="label-primary" htmlFor="checkbox-status"></label>
        </span>
    );
}

function findEstadoSiguiente(productoId, selectedId, siguientes) {


    let estadosSiguientes = [];
    for (var i = 0; i < siguientes.length; i++) {
        if (siguientes[i].ProductoId == productoId)
            estadosSiguientes.push(siguientes[i]);
    }

    const findSiguiente = siguientes.find(s => s.ProductoId == productoId && s.DeliveryEstadoId == selectedId);
    const estadoSiguiente = findSiguiente == undefined ? null : findSiguiente.SiguienteDeliveryEstadoId;
    const estadoAnterior = findSiguiente == undefined ? null : findSiguiente.AnteriorDeliveryEstadoId;

    return {
        anterior: estadoAnterior,
        siguiente: estadoSiguiente,
        estadosSiguientes: estadosSiguientes
    }
}

class PantallaCambioMasivo extends Component {

    constructor(props) {
        super(props);

        const { estados, grupoACambiar, selectedKey, siguientes } = props;
        const selectedId = estados.find(e => e.Descripcion === selectedKey);
        const estadosFind = findEstadoSiguiente(grupoACambiar[0].productoId, selectedId, siguientes);
        const estadoAnteriorExiste = estadosFind.anterior <= 2 ? null : estadosFind.anterior;

        const soloUnEstado = (estadosFind.siguiente === null && estadoAnteriorExiste !== null) || (estadosFind.siguiente !== null && estadoAnteriorExiste === null);
        const estadoInicialId = (estadosFind.siguiente === null ? estadosFind.anterior : estadosFind.siguiente);

        if (soloUnEstado) {

            this.state = { estadoDestino: estadoInicialId };
        }
        else
            this.state = { estadoDestino: null };

    }

    seleccionarEstadoDestino(id) {
        this.setState({ estadoDestino: id });
    }

    render() {

        const { estados, grupoACambiar, selectedKey, siguientes, tipoId } = this.props;
        const selectedId = estados.find(e => e.Descripcion === selectedKey).Id;
        const estadosFind = findEstadoSiguiente(grupoACambiar[0].productoId, selectedId, siguientes);

        const estadoSiguienteACambiar = estados.find(e => e.Id == estadosFind.siguiente);

        const estadoAnterior = estados.find(e => e.Id === estadosFind.anterior);

        return (
            <div className="CambioMasivoText">
                <p>Cambiar tarjetas y/o pines</p>
                <br />
                <p><span className="TipoPlasticoEstado">{selectedKey}</span></p>
                <br />
                <p>Seleccione el estado al que desea cambiar</p>
                <br />
                <div className="CambiarEstadoLabelContainer">
                    <MenuCambiarEstado
                        estadoDestino={this.state.estadoDestino}
                        seleccionarEstadoDestino={this.seleccionarEstadoDestino.bind(this)}
                        siguiente={estadosFind.estadosSiguientes}
                        anterior={estadoAnterior}
                        estados={estados}
                        estadoSelectedId={selectedId}
                    />
                </div>

                <BotonCambioMasivo grupoACambiar={grupoACambiar} estadoDestino={this.state.estadoDestino} cambiarEstadoFn={this.props.cambiarEstadoFn.bind(this)} />

            </div>
        );

    }

}

const BotonCambioMasivo = ({ cambiarEstadoFn, grupoACambiar, estadoDestino }) => {

    if (estadoDestino === null)
        return (
            <div className="CambioMasivoFooter">
                <button
                    className="btn btn-primary btn-disabled disabled CambioMasivoButton"
                    type="button"
                    onClick={() => { }}
                >
                    <p>Debe elegir un estado al que cambiar.</p>
                </button>
            </div>
        );

    return (
        <div className="CambioMasivoFooter">
            <button
                className="btn btn-primary CambioMasivoButton"
                type="button"
                onClick={() => cambiarEstadoFn(grupoACambiar, estadoDestino)}
            >
                <p>Cambiar a este estado</p>
            </button>
        </div>
    );
}

const MenuCambiarEstado = ({ siguiente, anterior, seleccionarEstadoDestino, estadoDestino, estados, estadoSelectedId }) => {

    const siguienteNulo = (siguiente === null || siguiente === undefined);
    const anteriorNulo = (anterior === null || anterior === undefined);

    let menu = [];
    if (siguiente.length > 0) {
        for (var i = 0; i < siguiente.length; i++) {
            if (estadoSelectedId == siguiente[i].DeliveryEstadoId) {
                let e = estados.find(e => e.Id == siguiente[i].SiguienteDeliveryEstadoId);
                if (e !== undefined) {
                    menu.push(<MenuItem>
                        <p className={"EstadoACambiarParrafo" + (estadoDestino == e.Id ? " Selected" : "")} onClick={() => seleccionarEstadoDestino(e.Id)}>
                            <span className="TipoPlasticoEstado EstadoACambiar">{e.Descripcion}</span>
                            {estadoDestino == siguiente[i].SiguienteDeliveryEstadoId ? <Icon name="check" className="IconoVerificarVerde" /> : <CheckboxEstado />}
                        </p>
                    </MenuItem>);
                }
            }

        }
    }

    return (
        <Menu>
            {siguienteNulo ? null :
                menu
            }
            {anteriorNulo ? null :
                <MenuItem>
                    <p className={"EstadoACambiarParrafo" + (estadoDestino == anterior.Id ? " Selected" : "")} onClick={() => seleccionarEstadoDestino(anterior.Id)}>
                        <span className="TipoPlasticoEstado EstadoACambiar">{anterior.Descripcion}</span>
                        {estadoDestino == anterior.Id ? <Icon name="check" className="IconoVerificarVerde" /> : <CheckboxEstado />}
                    </p>
                </MenuItem>
            }
        </Menu>
    );
}

export default PantallaCambioMasivo;